import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={24}
    height={23}
    viewBox='0 0 24 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.305 20.265a.69.69 0 0 0 .556-.273l.935-1.224c.194-.255.454-.4.731-.418.288-.018.556.11.778.336 1.343 1.406 2.361 1.288 2.852 1.107.5-.19 1.343-.817 1.343-2.83V6.746c0-4.028-1.185-5.253-5.065-5.253H8.444c-3.88 0-5.066 1.225-5.066 5.253v3.865c0 .372.315.68.695.68s.694-.308.694-.68V6.747c0-3.275.584-3.892 3.677-3.892h6.99c3.094 0 3.677.617 3.677 3.892v10.215c0 .953-.24 1.479-.463 1.56-.167.064-.62-.027-1.324-.761-.51-.527-1.176-.808-1.87-.772a2.4 2.4 0 0 0-1.77.962l-.944 1.225a.67.67 0 0 0 .14.952c.138.1.286.137.425.137'
      fill='#000'
    />
    <path
      d='M8.25 7.391h7.407c.38 0 .695-.308.695-.68a.693.693 0 0 0-.695-.68H8.25a.693.693 0 0 0-.694.68c0 .372.314.68.694.68m.925 3.629h5.556c.38 0 .695-.308.695-.68a.693.693 0 0 0-.695-.68H9.175a.693.693 0 0 0-.694.68c0 .372.315.68.694.68m.167 9.1c.352 0 .685-.128.926-.364.287-.28.416-.69.352-1.116l-.176-1.224a1.8 1.8 0 0 0-.472-.926l-3.278-3.21c-.445-.436-.88-.662-1.352-.708-.575-.054-1.149.182-1.686.708s-.778 1.08-.722 1.65c.046.454.287.89.722 1.325l3.278 3.212c.232.227.62.417.945.463l1.25.172c.074.01.139.018.213.018m-4.158-6.197h.028c.13.009.306.127.5.317l3.278 3.212a.34.34 0 0 1 .074.154l.167 1.134-1.158-.163a.5.5 0 0 1-.157-.082l-3.278-3.211c-.195-.2-.315-.363-.324-.49-.019-.182.166-.4.324-.554.148-.145.361-.317.546-.317'
      fill='#000'
    />
    <path
      d='M4.62 16.917a.6.6 0 0 0 .184-.027 3.65 3.65 0 0 0 2.538-2.486.687.687 0 0 0-.482-.844.69.69 0 0 0-.852.472 2.26 2.26 0 0 1-1.574 1.542.683.683 0 0 0 .185 1.343'
      fill='#000'
    />
  </svg>
);
export default SVGComponent;
